/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {CreateResourceRequest} from '../models/CreateResourceRequest';
import type {DeleteResourceRequest} from '../models/DeleteResourceRequest';
import type {EntitlementResource} from '../models/EntitlementResource';
import type {Error} from '../models/Error';
import type {ResourceList} from '../models/ResourceList';
import type {UpdateResourceRequest} from '../models/UpdateResourceRequest';

export interface CreateResource$Request {
    createResourceRequest: CreateResourceRequest;
}

export interface CreateResource$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const createResourceRequest = createAction<PayloadData<void, CreateResource$Request>>('ENTITLEMENTS_RESOURCE__CREATE_RESOURCE__REQUEST');
export const createResourceSuccess = createAction<PayloadData<void, CreateResource$Request>>('ENTITLEMENTS_RESOURCE__CREATE_RESOURCE__SUCCESS');
export const createResourceFailure = createAction<PayloadData<Error, CreateResource$Request, true>>('ENTITLEMENTS_RESOURCE__CREATE_RESOURCE__FAILURE');

export const createResourceActions = [
    createResourceRequest,
    createResourceSuccess,
    createResourceFailure
] as const;

/**
 * @param {CreateResourceRequest} meta.createResourceRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const createResource = (meta: CreateResource$Request, config?: CreateResource$Config) => {
    return {
        CALL_API: {
            types: createResourceActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/entitlements/resources`,
            TRANSPORT_REQUEST_BODY: meta.createResourceRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface DeleteResource$Request {
    resourceId: string;
    deleteResourceRequest: DeleteResourceRequest;
}

export interface DeleteResource$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const deleteResourceRequest = createAction<PayloadData<void, DeleteResource$Request>>('ENTITLEMENTS_RESOURCE__DELETE_RESOURCE__REQUEST');
export const deleteResourceSuccess = createAction<PayloadData<void, DeleteResource$Request>>('ENTITLEMENTS_RESOURCE__DELETE_RESOURCE__SUCCESS');
export const deleteResourceFailure = createAction<PayloadData<Error, DeleteResource$Request, true>>('ENTITLEMENTS_RESOURCE__DELETE_RESOURCE__FAILURE');

export const deleteResourceActions = [
    deleteResourceRequest,
    deleteResourceSuccess,
    deleteResourceFailure
] as const;

/**
 * @param {string} meta.resourceId
 * @param {DeleteResourceRequest} meta.deleteResourceRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const deleteResource = (meta: DeleteResource$Request, config?: DeleteResource$Config) => {
    return {
        CALL_API: {
            types: deleteResourceActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/entitlements/resources/${meta.resourceId}`,
            TRANSPORT_REQUEST_BODY: meta.deleteResourceRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetResourcesByIds$Request {
    requestBody: Array<string>;
}

export interface GetResourcesByIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getResourcesByIdsRequest = createAction<PayloadData<void, GetResourcesByIds$Request>>('ENTITLEMENTS_RESOURCE__GET_RESOURCES_BY_IDS__REQUEST');
export const getResourcesByIdsSuccess = createAction<PayloadData<{ [key: string]: EntitlementResource; }, GetResourcesByIds$Request>>('ENTITLEMENTS_RESOURCE__GET_RESOURCES_BY_IDS__SUCCESS');
export const getResourcesByIdsFailure = createAction<PayloadData<Error, GetResourcesByIds$Request, true>>('ENTITLEMENTS_RESOURCE__GET_RESOURCES_BY_IDS__FAILURE');

export const getResourcesByIdsActions = [
    getResourcesByIdsRequest,
    getResourcesByIdsSuccess,
    getResourcesByIdsFailure
] as const;

/**
 * @param {Array<string>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getResourcesByIds = (meta: GetResourcesByIds$Request, config?: GetResourcesByIds$Config) => {
    return {
        CALL_API: {
            types: getResourcesByIdsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/entitlements/resources`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetResourcesWithoutRelations$Request {
    pageSize: number;
    pageNumber: number;
    namespace: string;
}

export interface GetResourcesWithoutRelations$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getResourcesWithoutRelationsRequest = createAction<PayloadData<void, GetResourcesWithoutRelations$Request>>('ENTITLEMENTS_RESOURCE__GET_RESOURCES_WITHOUT_RELATIONS__REQUEST');
export const getResourcesWithoutRelationsSuccess = createAction<PayloadData<ResourceList, GetResourcesWithoutRelations$Request>>('ENTITLEMENTS_RESOURCE__GET_RESOURCES_WITHOUT_RELATIONS__SUCCESS');
export const getResourcesWithoutRelationsFailure = createAction<PayloadData<Error, GetResourcesWithoutRelations$Request, true>>('ENTITLEMENTS_RESOURCE__GET_RESOURCES_WITHOUT_RELATIONS__FAILURE');

export const getResourcesWithoutRelationsActions = [
    getResourcesWithoutRelationsRequest,
    getResourcesWithoutRelationsSuccess,
    getResourcesWithoutRelationsFailure
] as const;

/**
 * @param {number} meta.pageSize
 * @param {number} meta.pageNumber
 * @param {string} meta.namespace
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getResourcesWithoutRelations = (meta: GetResourcesWithoutRelations$Request, config?: GetResourcesWithoutRelations$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageSize: meta.pageSize,
        pageNumber: meta.pageNumber,
        namespace: meta.namespace,
    };
    return {
        CALL_API: {
            types: getResourcesWithoutRelationsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/entitlements/resources`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UpdateResource$Request {
    resourceId: string;
    updateResourceRequest: UpdateResourceRequest;
}

export interface UpdateResource$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const updateResourceRequest = createAction<PayloadData<void, UpdateResource$Request>>('ENTITLEMENTS_RESOURCE__UPDATE_RESOURCE__REQUEST');
export const updateResourceSuccess = createAction<PayloadData<void, UpdateResource$Request>>('ENTITLEMENTS_RESOURCE__UPDATE_RESOURCE__SUCCESS');
export const updateResourceFailure = createAction<PayloadData<Error, UpdateResource$Request, true>>('ENTITLEMENTS_RESOURCE__UPDATE_RESOURCE__FAILURE');

export const updateResourceActions = [
    updateResourceRequest,
    updateResourceSuccess,
    updateResourceFailure
] as const;

/**
 * @param {string} meta.resourceId
 * @param {UpdateResourceRequest} meta.updateResourceRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const updateResource = (meta: UpdateResource$Request, config?: UpdateResource$Config) => {
    return {
        CALL_API: {
            types: updateResourceActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/entitlements/resources/${meta.resourceId}`,
            TRANSPORT_REQUEST_BODY: meta.updateResourceRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

